<mat-card *ngIf="integration$ | async; let integration">
    <mat-card-title>Welcome {{ integration.user.profile.displayName }}</mat-card-title>
    <mat-card-subtitle>Please enable Twitter account that you want to integrate with UDM.</mat-card-subtitle>
    <mat-card-content>
        <mat-slide-toggle (click)="toggle(integration)" [checked]="integration.channel">{{ integration.user.profile.username }}</mat-slide-toggle>
    </mat-card-content>
</mat-card>